import { AnimalScaleFilter } from 'store/Project/ProjectTypes'

export function animalScaleFilterActive(byAnimalScale: {
  filter: AnimalScaleFilter
  active: boolean
}) {
  if (!byAnimalScale?.active || !byAnimalScale.filter?.availableFilters) {
    return false
  }

  return true
}
